import React from "react";
import { number, bool } from "prop-types";

import Icon from "../icon";

const Youtube = ({ width = 28, height = 28, isShareRequired }) => (
  <Icon type="youtube" isShareRequired={isShareRequired}>
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 28 28">
      <g transform="translate(-10 -5)">
        <path d="M0 0h28v28H0z" fill="rgba(255,255,255,0)" transform="translate(10 5)" />
        <g transform="translate(3.001 -24)">
          <path
            d="M33.45 36.86a3.266 3.266 0 0 0-2.3-2.313C29.125 34 21 34 21 34s-8.128 0-10.155.547a3.266 3.266 0 0 0-2.3 2.313A34.258 34.258 0 0 0 8 43.157a34.258 34.258 0 0 0 .543 6.3 3.266 3.266 0 0 0 2.3 2.313c2.027.547 10.155.547 10.155.547s8.128 0 10.155-.547a3.266 3.266 0 0 0 2.3-2.313 34.259 34.259 0 0 0 .543-6.3 34.259 34.259 0 0 0-.546-6.297z"
            fill="#fff"
          />
          <path d="M78 77.567l6.8-3.867-6.8-3.869z" fill="red" transform="translate(-59.665 -30.542)" />
        </g>
      </g>
    </svg>
  </Icon>
);

Youtube.propTypes = {
  width: number,
  height: number,
  isShareRequired: bool,
};

export default Youtube;
